import { useInnerWidth } from '@/hooks/useInnerWidth';
import { DeviceBreakpointsEnum } from '@/types/deviceBreakpoints.enum';

export const useIsMobileDevice = () => {
  const width = useInnerWidth();
  return width <= DeviceBreakpointsEnum.Mobile;
};
